import { browser } from "$app/environment"
import { Capacitor } from "@capacitor/core"
import { StatusBar, Style } from "@capacitor/status-bar"

// Color de los iconos de la status bar (reloj, senal, bateria) en la app nativa.
//
// Por que hace falta: el tema del WebView lo elige el usuario con el boton del
// solcito y se guarda en localStorage, asi que puede NO coincidir con el modo
// oscuro del sistema. El calificador `values-night/` de Android sigue al
// sistema, no a la app: con el celu en claro y la app en oscura dejaba los
// iconos oscuros sobre el navbar oscuro (ilegible). Este es el unico camino que
// sigue al tema real de la app.
//
// Ojo con los nombres del plugin, que se leen al reves de lo que uno espera:
// `Style.Dark` = fondo oscuro -> iconos CLAROS; `Style.Light` = fondo claro ->
// iconos OSCUROS.
export async function sincronizarStatusBar(oscuro) {
    if (!browser || !Capacitor.isNativePlatform()) return
    try {
        await StatusBar.setStyle({ style: oscuro ? Style.Dark : Style.Light })
    } catch (err) {
        // En web el plugin no existe y en un WebView viejo puede fallar: el
        // color de la status bar no vale romper el cambio de tema.
        console.warn("[statusbar]", err)
    }
}

export function createDarker(){
    let modo = "no"
    if(browser){
        modo = localStorage.getItem("oscuro")||"no"
    }
    
    let dark = $state(modo == "si")
    return {
        get dark() {return dark},
        setDark: (mode)=>{
            if(browser){
                localStorage.setItem("oscuro",mode?"si":"no")
            
                dark = mode
                sincronizarStatusBar(mode)
            }
            
        }
    }
}